/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductOrderDemandDetailResponseDto>
>;
export function request(
  params: API.basics.productOrderDemandDetail.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productOrderDemandDetail/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
